<template>
  <div class="reviewdetails">
    <br />
    <br />
    <br />
    <!-- <a class="no-print" @click="printDiv">Print</a> -->
    <div class="columns is-mobile" ref="pdfContent">
      <div class="column is-full">
        <h3 class="title" style="font-weight: normal; text-transform: none;color:#004771">
          Claims Reporting Details: {{ $route.params.id }}
          &nbsp;
          <b-button class="no-print is-warning" @click="printDiv">Print</b-button>
        </h3>
        <b-message type="is-warning" has-icon v-if="!fnoldata">
          <p>
            Error - Retriving claims data for {{ $route.params.id }}
            {{fnoldata}}
            <br />
          </p>
          <!-- <button
              class="button is-danger is-outlined"
              style="width: 100px;"
              outlined
              @click="onClick()"
          >Back</button>-->
        </b-message>
        <div class="columns is-mobile" v-else>
          <div class="column">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">Basic Info</p>
              </header>
              <div class="card-content">
                <div class="content">
                  <div class="columns is-mobile">
                    <div class="column">
                      <div class="columns">
                        <div class="column">
                          <b-field label="Policy Number" expanded>{{ fnoldata.policy.policyNumber}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Covered State"
                            expanded
                          >{{typeListDescription(fnoldata.jurisdictionState, "StateType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Submit without Policy?"
                            expanded
                          >{{formatYNBoolean(fnoldata.policy.npAgreement)}}</b-field>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Who are you?"
                            expanded
                          >{{ typeListDescription(fnoldata.preparer.title, "SubmitterType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="When did injury occur?"
                            expanded
                          >{{getDateFormatted(fnoldata.injury.dateOfInjury)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Time of injury/illness occured"
                          >{{fnoldata.injury.timeOfInjury}}</b-field>
                        </div>
                      </div>
                      <b-field label="Name">{{fnoldata.preparer.name}}</b-field>
                      <b-field
                        label="How do you want us to notify you?"
                      >{{fnoldata.preparer.notifyBy}}</b-field>
                      <b-field label="Email">{{fnoldata.preparer.email}}</b-field>
                      <b-field label="Phone">{{formatPhone(fnoldata.preparer.phone.work)}}</b-field>
                      <b-field
                        label="I agree with Republic's Claims Reporting Agreement"
                      >{{ formatYNBoolean(fnoldata.tosAgreement) }}</b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <!-- Employer -->
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">Employer</p>
              </header>
              <div class="card-content">
                <div class="content">
                  <div class="columns is-mobile">
                    <div class="column">
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Has employer been informed of alleged injury claim?"
                            expanded
                          >{{formatYNBoolean(fnoldata.employer.empInformed)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Date of Employer's Knowledge/Notice of Injury"
                            expanded
                          >{{getDateFormatted(fnoldata.injury.dateReportedToEmployer)}}</b-field>
                        </div>
                      </div>
                      <b-field label="Employer Name">{{fnoldata.employer.name}}</b-field>
                      <b-field label="Mailing Address">{{fnoldata.employer.address.street}}</b-field>
                      <div class="columns">
                        <div class="column">
                          <b-field label="City" expanded>{{fnoldata.employer.address.city}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="State"
                            expanded
                          >{{ typeListDescription(fnoldata.employer.address.state, "StateType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Zip code">{{fnoldata.employer.address.zip}}</b-field>
                        </div>
                      </div>

                      <b-collapse :open="false" aria-id="differentaddress">
                        <b-field
                          label="Is injury accident location different than mailing address?"
                          expanded
                        >{{ fnoldata.injury.onEmployerPremises }}</b-field>
                        <br />
                        <div class="content" aria-controls="differentaddress">
                          <b-field
                            label="Location where Event or Exposure Occurred (Number,Street,City,Zip)"
                          >{{fnoldata.injury.locationEventOccured}}</b-field>
                        </div>
                      </b-collapse>
                      <br />
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Phone"
                            expanded
                          >{{formatPhone(fnoldata.employer.phone.work)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Fax" expanded>{{formatPhone(fnoldata.employer.phone.fax)}}</b-field>
                        </div>
                      </div>
                      <b-field
                        label="Employer contact name"
                        expanded
                      >{{fnoldata.employer.contactName}}</b-field>
                      <b-field label="Email" expanded>{{fnoldata.employer.email}}</b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Injured Worker -->
            <br />
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">Injured Worker</p>
              </header>
              <div class="card-content">
                <div class="content">
                  <!-- Content for Injured Worker -->
                  <div class="columns is-mobile">
                    <div class="column">
                      <div class="columns">
                        <div class="column">
                          <b-field label="First Name" expanded>{{fnoldata.employee.firstName}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Last name" expanded>{{fnoldata.employee.lastName}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Middle Init" expanded>{{fnoldata.employee.middleInitials}}</b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column">
                          <b-field label="Social security #">{{formatSSN(fnoldata.employee.ssn)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Birth date"
                            expanded
                          >{{getDateFormatted(fnoldata.employee.dateOfBirth)}}</b-field>
                        </div>
                      </div>
                      <b-field label="Mailing address">{{fnoldata.employee.address.street}}</b-field>
                      <div class="columns">
                        <div class="column">
                          <b-field label="City" expanded>{{fnoldata.employee.address.city}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="State"
                          >{{typeListDescription(fnoldata.employee.address.state,"StateType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field label="Zip code">{{fnoldata.employee.address.zip}}</b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column">
                          <b-field label="Phone">{{formatPhone(fnoldata.employee.phone.mobile)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Gender"
                            expanded
                          >{{typeListDescription(fnoldata.employee.gender,"GenderType")}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Date of hire"
                            expanded
                          >{{getDateFormatted(fnoldata.employment.dateOfHiring)}}</b-field>
                        </div>
                      </div>
                      <b-field label="Occupation" expanded>{{fnoldata.employment.occupation}}</b-field>
                      <br />
                      <b-field
                        label="Employment status"
                      >{{typeListDescription(fnoldata.employment.employmentStatus, "EmpStatus")}}</b-field>
                      <br />
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Employee usual work hours"
                          >{{fnoldata.employment.hoursPerDay}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Days per week"
                            expanded
                          >{{fnoldata.employment.daysPerWeek}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Total weekly hours?"
                            expanded
                          >{{fnoldata.employment.totalWeeklyHours}}</b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Gross wages/salary ($)"
                            expanded
                          >{{fnoldata.employment.grossWages}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Pay Period"
                            expanded
                          >{{typeListDescription(fnoldata.employment.grossWagePer,"WagePaidType")}}</b-field>
                        </div>
                      </div>
                      <b-field
                        label="Other wages reported? (eg. Tips, meals, lodging, bonus..)"
                      >{{formatYNBoolean(fnoldata.employment.opy)}}</b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Injured Worker Details-->
            <br />
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">Injury Details</p>
              </header>
              <div class="card-content">
                <div class="content">
                  <!-- Content for Injured Worker Details -->
                  <div class="columns is-mobile">
                    <div class="column">
                      <b-field
                        label="How Injury/Illness Occurred; Describe Sequence ofEvents"
                      >{{fnoldata.injury.claimInjuryDescription}}</b-field>
                      <b-field
                        label="Other Workers Injured/Ill in this event?"
                        expanded
                      >{{formatYNBoolean(fnoldata.injury.rbOthInj)}}</b-field>
                      <b-field
                        label="Part of Body Affected"
                        expanded
                      >{{typeListDescription(fnoldata.injury.bodyPart, "BodyPartType")}}</b-field>
                      <b-field
                        label="Medical Diagnosis (If available)"
                      >{{fnoldata.injury.medicalDiagnosis}}</b-field>

                      <b-field
                        label="If employee died, date of death"
                        expanded
                      >{{getDateFormatted(fnoldata.injury.dateofDeath)}}</b-field>
                      <b-field
                        label="Unable to work atleast one full day after date of Injury?"
                      >{{formatYNBoolean(fnoldata.injury.rbOneDay)}}</b-field>
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Date Last worked"
                            expanded
                          >{{getDateFormatted(fnoldata.injury.dateLastWeekWorked)}}</b-field>
                          <b-field
                            label="Date returned to work"
                            expanded
                          >{{getDateFormatted(fnoldata.injury.employeeReturnedToWork)}}</b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column">
                          <b-field
                            label="Still off work?"
                            expanded
                          >{{formatYNBoolean(fnoldata.injury.rbInjoffWk)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label=" Paid Full Wages, For Day Of Injury, Or Last Day Worked?"
                            expanded
                          >{{formatYNBoolean(fnoldata.injury.employeePaidInjuryDay)}}</b-field>
                        </div>
                        <div class="column">
                          <b-field
                            label="Salary being continued?"
                            expanded
                          >{{formatYNBoolean(fnoldata.injury.employeeSalaryContinuted)}}</b-field>
                        </div>
                      </div>

                      <b-field
                        label="Injured worker treated in emergency room?"
                        slot="trigger"
                        aria-controls="hospitalizedarea"
                      >{{formatYNBoolean(fnoldata.hospital.emergency)}}</b-field>
                      <br />
                      <div
                        class="card"
                        aria-controls="hospitalizedarea"
                        v-if="fnoldata.hospital.emergency==='Y'"
                      >
                        <div class="card-header" aria-controls="hospitalizedarea">
                          <p class="card-header-title">Hospital Information</p>
                        </div>
                        <div class="card-content" aria-controls="hospitalizedarea">
                          <div class="content" aria-controls="hospitalizedarea">
                            <b-field label="Name">{{fnoldata.hospital.name}}</b-field>
                            <b-field
                              label="Hospitalized as an Inpatient?"
                              slot="trigger"
                              aria-controls="hospitalizedarea"
                            >{{formatYNBoolean(fnoldata.injury.hospitaliz)}}</b-field>
                            <b-field label="Phone">{{formatPhone(fnoldata.hospital.phone.work)}}</b-field>
                            <b-field label="Mailing Address">{{fnoldata.hospital.address.street}}</b-field>
                            <div class="columns">
                              <div class="column">
                                <b-field label="City" expanded>{{fnoldata.hospital.address.city}}</b-field>
                              </div>
                              <div class="column">
                                <b-field
                                  label="State"
                                  expanded
                                >{{typeListDescription(fnoldata.hospital.address.state,"StateType")}}</b-field>
                              </div>
                              <div class="column">
                                <b-field label="Zip code">{{fnoldata.hospital.address.zip}}</b-field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <br />

                      <b-field
                        label="Did injured worker seek medical treatment?"
                        slot="trigger"
                        aria-controls="medicaltreatmentarea"
                      >{{formatYNBoolean(fnoldata.injury.seekMedicalTreatment)}}</b-field>
                      <br />
                      <div
                        class="card"
                        aria-controls="medicaltreatmentarea"
                        v-if="fnoldata.injury.seekMedicalTreatment==='Y'"
                      >
                        <div class="card-header" aria-controls="medicaltreatmentarea">
                          <p class="card-header-title">Physician/Clinic Information</p>
                        </div>
                        <div class="card-content" aria-controls="medicaltreatmentarea">
                          <div class="content" aria-controls="medicaltreatmentarea">
                            <b-field label="Name">{{fnoldata.physicianORClinic.name}}</b-field>
                            <b-field
                              label="Phone"
                            >{{formatPhone(fnoldata.physicianORClinic.phone.work)}}</b-field>
                            <b-field
                              label="Mailing Address"
                            >{{fnoldata.physicianORClinic.address.street}}</b-field>
                            <div class="columns">
                              <div class="column">
                                <b-field
                                  label="City"
                                  expanded
                                >{{fnoldata.physicianORClinic.address.city}}</b-field>
                              </div>
                              <div class="column">
                                <b-field
                                  label="State"
                                  expanded
                                >{{typeListDescription(fnoldata.physicianORClinic.address.state,"StateType")}}</b-field>
                              </div>
                              <div class="column">
                                <b-field label="Zip code">{{fnoldata.physicianORClinic.address.zip}}</b-field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Closing columns and column -->
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
    </div>
    <!--<a @click="genPDF">Print to PDF</a>-->
  </div>
</template>

<script>
import { ClaimsReview } from "../utils/services";
import moment from "moment";
import {
  PhoneFormatter,
  SSNFormatter,
  YNBooleanFormatter
} from "../utils/util";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import TypeLists from "../data/typelists";

export default {
  name: "reviewdetails",
  data() {
    return {
      fnoldata: {},
      detaildBodyPartList: TypeLists.DetailedBodyPart,
      stateMap: TypeLists.StatesFiltered,
      genderType: TypeLists.GenderType,
      submitterType: TypeLists.SubmitterType,
      wagePaidType: TypeLists.WagesPaidType,
      employmentStatus: TypeLists.EmploymentStatus
    };
  },
  methods: {
    onClick() {
      alert(this.$route.params.id);
    },
    printDiv() {
      window.print();
    },
    // genPDF() {
    //   const contentHTML = this.$refs.pdfContent;
    //   var canvasElement = document.createElement("canvas");
    //   html2canvas(this.$refs.pdfContent, { canvas: canvasElement }).then(
    //     function(canvas) {
    //       const img = canvas.toDataURL("image/png");
    //       var imgWidth = 210;
    //       var pageHeight = 295;
    //       var imgHeight = (canvas.height * imgWidth) / canvas.width;
    //       var heightLeft = imgHeight;
    //       var doc = new jsPDF("p", "mm");
    //       var position = 0;

    //       doc.addImage(img, "PNG", 0, position, imgWidth, imgHeight);
    //       heightLeft -= pageHeight;

    //       while (heightLeft >= 0) {
    //         position = heightLeft - imgHeight;
    //         doc.addPage();
    //         doc.addImage(img, "PNG", 0, position, imgWidth, imgHeight);
    //         heightLeft -= pageHeight;
    //       }

    //       doc.save("fnol.pdf");
    //     }
    //   );
    // },
    getDateFormatted: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    },
    getJsonToString: function(value) {
      if (value) {
        return JSON.stringify(value);
      }
    },
    formatSSN: function(value) {
      return SSNFormatter(value);
    },
    formatPhone: function(value) {
      return PhoneFormatter(value);
    },
    formatTime: function(value) {
      if (value) {
        return moment(String(value)).format("hh:mm A");
      }
      return value;
    },
    formatYNBoolean: function(value) {
      if (value) {
        return YNBooleanFormatter(value);
      } else {
        return value;
      }
    },
    typeListDescription: function(value, typelist) {
      var desc = null;
      if (typelist === "StateType") {
        return this.stateMap[value];
      } else if (typelist === "BodyPartType") {
        return this.detaildBodyPartList[value];
      } else if (typelist === "GenderType") {
        desc = this.genderType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "WagePaidType") {
        desc = this.wagePaidType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "SubmitterType") {
        desc = this.submitterType.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else if (typelist === "EmpStatus") {
        desc = this.employmentStatus.find(o => o.code == value);
        if (desc) {
          return desc.name;
        } else {
          return "";
        }
      } else {
        return;
      }
    }
  },

  created() {
    if (this.$route.params.id) {
      ClaimsReview(this.$route.params.id)
        .then(res => {
          this.fnoldata = res;
        })
        .catch(err => {
          alert(err);
          this.fnoldata = {};
        });
    }
  }
};
</script>

<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
.label {
  text-align: left;
  white-space: normal;
}
.b-component-header-nav {
  display: none;
}
.b-component-header-nav {
  display: none;
}
.b-component-footer {
  display: none;
}
</style>
